import { useState } from 'react';
import { MINIMUM_DOSE, MAXIMUM_DOSE, DOSE_STEP } from '../shared/constants.js';
import { useLanguage } from '../context/LanguageContext.js';
import { usei18n } from '../i18n/i18n.js';
import Modal from './Modal.js';
import './ChangePresetsModal.css';

const PresetStepper = ({ value, onChange, i18n }) => {
    const num = parseFloat(value);

    const decrement = () => {
        const next = Math.round((num - DOSE_STEP) * 10) / 10;
        if (next >= MINIMUM_DOSE) onChange(next.toFixed(1));
    };

    const increment = () => {
        const next = Math.round((num + DOSE_STEP) * 10) / 10;
        if (next <= MAXIMUM_DOSE) onChange(next.toFixed(1));
    };

    return (
        <div className="preset-stepper-row">
            <div className="preset-stepper">
                <button className="stepper-btn" onClick={decrement} disabled={num <= MINIMUM_DOSE}>−</button>
                <span className="stepper-value">{value} <span className="stepper-unit">{i18n('doseUnit')}</span></span>
                <button className="stepper-btn" onClick={increment} disabled={num >= MAXIMUM_DOSE}>+</button>
            </div>
        </div>
    );
};

const ChangePresetsModal = ({ presets, onSave, onClose }) => {
    const [values, setValues] = useState(presets.map(p => parseFloat(p).toFixed(1)));
    const {language} = useLanguage();
    const i18n = usei18n(language);
    const update = (i, val) => setValues(prev => prev.map((v, idx) => idx === i ? val : v));
    const save = (newPresets) => {
        onSave(newPresets);
        onClose();
    };
    return (
        <Modal onClose={onClose} onBackdropClick={onClose} zIndex={3}>
            <h3 className="change-presets-title">{i18n('modal.presets.title')}</h3>
            {values.map((val, i) => (
                <PresetStepper key={i} value={val} onChange={(v) => update(i, v)} i18n={i18n}/>
            ))}
            <button className="save-presets" onClick={() => save(values)}>{i18n('modal.presets.save')}</button>
        </Modal>
    );
};

export default ChangePresetsModal;
